import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "../winrm/logo.svg";
import { CLIENT_CONTEXT, endpoint, publicEnvVars, usageHint } from "./shared";

export const vnc = defineConnector({
  identifier: "vnc",
  name: "VNC",
  tagLine: "Access a remote desktop through VNC",
  keywords: "vnc rfb remote desktop screen sharing computer",
  logo,
  tags: ["it", "custom"],
  protocol: "vnc",
  defaultUrlPattern: () => "",
  customizeStepHandledInline: true,
  auth: customAuth("vnc"),
  aiContext: `VNC remote desktop access using the server’s VNC password. For Mac account authentication, use the Apple Remote Desktop connector. ${CLIENT_CONTEXT}`,
  steps: [
    {
      title: "Connect to a remote desktop",
      items: [
        {
          kind: "input",
          label: "Name",
          required: true,
          defaultValue: "VNC",
          target: { kind: "connectedApp", field: "name" },
        },
        {
          kind: "hostname",
          label: "Host",
          required: true,
          placeholder: "desktop.example.com",
          target: { kind: "configuration", field: "host" },
        },
        {
          kind: "input",
          label: "Port",
          required: true,
          defaultValue: "5900",
          target: { kind: "configuration", field: "port" },
        },
        {
          kind: "input",
          label: "VNC password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
        {
          kind: "markdown",
          content:
            "Enter the server’s VNC password. VNC uses only the first eight bytes of the password. For a Mac account’s username and password, choose the Apple Remote Desktop connector. Use a tunnel or a trusted private network; this connector does not encrypt desktop traffic.",
        },
      ],
    },
  ],
  connectionTest: { protocol: "vnc", connectionString: endpoint },
  publicEnvVars,
  usageHint,
});
